// extracted by mini-css-extract-plugin
export default {"sticky":"StickyNavbar_sticky__QTAXx","nav_content":"StickyNavbar_nav_content__Armop"};